// Recovered compiled webpack factory 48182. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { FadeUp: () => o, SplitText: () => l });
  var n = r(95155),
    a = r(12115),
    s = r(10798),
    i = r.n(s);
  function l(e) {
    let { text: t, className: r = "", delay: s = 0, stagger: l = 0.035, duration: o = 0.52 } = e,
      c = t.trim().split(/\s+/);
    return (0, n.jsxs)("span", {
      className: r,
      children: [
        (0, n.jsx)("span", { className: "sr-only !select-none", children: t }),
        (0, n.jsx)("span", {
          "aria-hidden": "true",
          children: c.map((e, t) =>
            (0, n.jsxs)(
              a.Fragment,
              {
                children: [
                  (0, n.jsx)("span", {
                    className: i().word,
                    style: { "--entrance-delay": `${s + t * l}s`, "--entrance-duration": `${o}s` },
                    children: e,
                  }),
                  t < c.length - 1 ? " " : null,
                ],
              },
              t,
            ),
          ),
        }),
      ],
    });
  }
  function o(e) {
    let {
        children: t,
        className: r = "",
        delay: s = 0,
        duration: l = 0.55,
        y: o = 14,
        inView: c = !1,
      } = e,
      d = (0, a.useRef)(null),
      [u, m] = (0, a.useState)(!c);
    return (
      (0, a.useEffect)(() => {
        if (!c || !d.current) return;
        if (!("IntersectionObserver" in window)) return void m(!0);
        let e = new IntersectionObserver(
          (t) => {
            let [r] = t;
            r.isIntersecting && !(r.intersectionRatio < 0.08) && (m(!0), e.disconnect());
          },
          { threshold: 0.08 },
        );
        return (e.observe(d.current), () => e.disconnect());
      }, [c]),
      (0, n.jsxs)("div", {
        ref: d,
        className: `${i().block} ${r}`,
        "data-visible": u,
        style: {
          "--entrance-delay": `${s}s`,
          "--entrance-duration": `${l}s`,
          "--entrance-rise": `${o}px`,
        },
        children: [
          c &&
            (0, n.jsx)("noscript", {
              children: (0, n.jsx)("style", {
                children: `.${i().block}[data-visible="false"]{opacity:1;transform:none}`,
              }),
            }),
          t,
        ],
      })
    );
  }
}
